import { states } from "../../../../constants/data";
import Styles from "../editScreenStyles.module.css";
import { vehicleMakes, yesNo } from "../../../../constants/options";

function OtherVehicleEdit({
  fields,
  utilities,
  updateClicked,
  cancelClicked
}) {

  const {
    createToggleInput,
    createNoLabelInput,
    createNoLabelSelect,
    createCustomLabelTextArea,
  } = utilities;

  return (
    <div className={Styles.modalContainer}>
      <div className={Styles.title}>Other Vehicle</div>
      <div className={Styles.column}>
        {createToggleInput(fields.otherVehicleInvolved, "100%", yesNo, true)}
        {fields.otherVehicleInvolved.value && (
          <div className={Styles.hiddenDiv}>
            <p className={Styles.title}>Other Vehicle Information</p>
            <div className={Styles.row}>
              {createNoLabelInput(fields.otherVehicleYear, "100%", Styles.input)}
              {createNoLabelSelect(
                fields.otherVehicleMake,
                "100%",
                vehicleMakes.map((make) => make.name),
                Styles.select,
                "Select a make"
              )}
              {createNoLabelInput(fields.otherVehicleModel, "100%", Styles.input)}
            </div>

            <div className={Styles.row}>
              {createNoLabelInput(fields.otherVehiclePlateNumber, "100%", Styles.input)}
              {createNoLabelSelect(
                fields.otherVehicleState,
                "100%",
                states,
                Styles.select,
                "Select a State"
              )}
            </div>

            <div className={Styles.column}>
              {createCustomLabelTextArea(
                fields.otherVehicleDescribe,
                "100%",
                Styles.textarea,
                Styles.blockLabel,
                {altLabel: "Describe the vehicle damage"}
              )}
            </div>
            <div className={Styles.row}>
              <div className={Styles.groupedInputs}>
                <p className={Styles.blockLabel}>
                  Who was driving the vehicle?
                </p>
                {createNoLabelInput(
                  fields.otherVehicleDriverFirstName,
                  "100%",
                  Styles.input
                  )}
                {createNoLabelInput(
                  fields.otherVehicleDriverLastName,
                  "100%",
                  Styles.input
                )}
              </div>
            </div>
            <p className={Styles.title}>Other Driver Information</p>
            <div className={Styles.row}>
              {createNoLabelInput(
                fields.otherVehicleDriverAddress,
                "100%",
                Styles.input
              )}
              {createNoLabelInput(
                fields.otherVehicleDriverCity,
                "100%",
                Styles.input
              )}
            </div>
            <div className={Styles.row}>
              {createNoLabelSelect(
                fields.otherVehicleDriverState,
                "100%",
                states,
                Styles.select,
                "Select a state"
              )}
              {createNoLabelInput(fields.otherVehicleDriverZipcode, "100%", Styles.input)}
              {createNoLabelInput(fields.otherVehicleDriverPhone, "100%", Styles.input, "tel")}
            </div>
            <div className={Styles.row}>
              <div style={{display: "inline-flex", flex: 1}}>
                {createToggleInput(fields.otherVehicleDriverInjured,"100%", yesNo, true)}
              </div>
              <div style={{display: "inline-flex", flex: 1}}>
                {createToggleInput(fields.otherDriverIsOwner, "100%", yesNo, true)}
              </div>
            </div>
            {!fields.otherDriverIsOwner.value && (
              <div className={Styles.hiddenDiv}>
                <p className={Styles.title}>Other Owner Information</p>
                <div className={Styles.row}>
                  {createNoLabelInput(fields.otherVehicleOwnerFirstName, "100%", Styles.input)}
                  {createNoLabelInput(fields.otherVehicleOwnerLastName, "100%", Styles.input)}
                </div>
                <div className={Styles.row}>
                  {createNoLabelInput(fields.otherVehicleOwnerAddress, "100%", Styles.input)}
                  {createNoLabelInput(fields.otherVehicleOwnerCity, "100%", Styles.input)}
                </div>
                <div className={Styles.row}>
                  {createNoLabelSelect(fields.otherVehicleOwnerState, "100%", states, Styles.select)}
                  {createNoLabelInput(fields.otherVehicleOwnerZipcode, "100%", Styles.input)}
                  {createNoLabelInput(fields.otherVehicleOwnerPhone, "100%", Styles.input)}
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      <div className={Styles.buttons}>
        <button type="button" className={Styles.button} onClick={cancelClicked}>
          Cancel
        </button>
        <button type="button" className={Styles.button} onClick={updateClicked}>
          Update
        </button>
      </div>
    </div>
  );
}

export default OtherVehicleEdit;
